/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {useLocation} from "react-router";
import {NavLink} from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl, checkIsActive} from "../../../../_helpers";
import {routes} from "../../../../../app/Routes";
import {useSelector} from "react-redux";


export function AsideMenuList({layoutProps}) {
    const {user} = useSelector(state => state.user);
    const role = user.role.name;
    const location = useLocation();
    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
            : "";
    };
    const menuItems = [
        {
            id: "3",
            name: "Users Management",
            des: "roles",
            customer: false,
            icon: "",
            path: "/"
        },
        {
            id: "4",
            name: "System Management",
            des: "system",
            customer: false,
            icon: "",
            path: "/"
        }
    ];

    return (
        <>
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                <li className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
                    aria-haspopup="true">
                    <NavLink className="menu-link" to="/dashboard">
                        <span className="svg-icon menu-icon">
                          <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
                        </span>
                        <span className="menu-text">داشبورد</span>
                    </NavLink>
                </li>


                <li className={`menu-item menu-item-submenu ${getMenuItemActive("/e-commerce", true)}`}
                    aria-haspopup="true"
                    data-menu-toggle="hover">
                    <NavLink className="menu-link menu-toggle" to="/e-commerce">
                        <span className="svg-icon menu-icon">
                          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")}/>
                        </span>
                        <span className="menu-text">eCommerce</span>
                    </NavLink>
                    <div className="menu-submenu">
                        <i className="menu-arrow"/>
                        <ul className="menu-subnav">
                            <li className="menu-item menu-item-parent" aria-haspopup="true">
                                <span className="menu-link">
                                  <span className="menu-text">eCommerce</span>
                                </span>
                            </li>
                            <li
                                className={`menu-item ${getMenuItemActive(
                                    "/e-commerce/customers"
                                )}`}
                                aria-haspopup="true">
                                <NavLink className="menu-link" to="/e-commerce/customers">
                                    <i className="menu-bullet menu-bullet-dot">
                                        <span/>
                                    </i>
                                    <span className="menu-text">Customers</span>
                                </NavLink>
                            </li>
                            <li
                                className={`menu-item ${getMenuItemActive(
                                    "/e-commerce/products"
                                )}`}
                                aria-haspopup="true">
                                <NavLink className="menu-link" to="/e-commerce/products">
                                    <i className="menu-bullet menu-bullet-dot">
                                        <span/>
                                    </i>
                                    <span className="menu-text">Products</span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </li>


                {menuItems.map((item, i) =>
                    role !== "customer" || item.customer ? (
                        <li key={i} className={`menu-item menu-item-submenu ${getMenuItemActive(item.path, true)}`}
                            aria-haspopup="true"
                            data-menu-toggle="hover">
                            <NavLink className="menu-link menu-toggle" to={item.path}>
                                        <span className="svg-icon menu-icon">
                                          {/*<SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag2.svg")}/>*/}
                                            <i className={item.icon}><span/></i>
                                        </span>
                                <span className="menu-text">{item.name}</span>
                            </NavLink>
                            <div className="menu-submenu">
                                <i className="menu-arrow"/>
                                <ul className="menu-subnav">
                                    <li className="menu-item menu-item-parent" aria-haspopup="true">
                                                <span className="menu-link">
                                                  <span className="menu-text">{item.name}</span>
                                                </span>
                                    </li>
                                    {routes.map((el, i) => {
                                        return el.sub === item.des &&
                                        (role !== "customer" || el.customer) ? (
                                            <li key={i}
                                                className={`menu-item ${getMenuItemActive("/e-commerce/customers")}`}
                                                aria-haspopup="true">
                                                <NavLink className="menu-link" to={el.path}>
                                                    <i className="menu-bullet menu-bullet-dot">
                                                        <span/>
                                                    </i>
                                                    <span className="menu-text">{el.name}</span>
                                                </NavLink>
                                            </li>
                                        ) : null;
                                    })}

                                </ul>
                            </div>
                        </li>

                    ) : null
                )}


            </ul>

        </>
    );
}
